module.exports = "<div class=\"help-text-container\">\n  <p>\n    <ng-content></ng-content>\n  </p>\n</div>\n"